import { render, staticRenderFns } from "./BranchCreationModal.vue?vue&type=template&id=b2c21e44&scoped=true&"
import script from "./BranchCreationModal.vue?vue&type=script&lang=ts&"
export * from "./BranchCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c21e44",
  null
  
)

export default component.exports